import { useState } from 'react';
import {
  SensitiveFieldType,
  SENSITIVE_FIELD_EXPLANATIONS,
} from '../../constants/sensitiveFieldExplanations';

interface SensitiveFieldHelpProps {
  fieldType: SensitiveFieldType;
  isMobile?: boolean;
  isTablet?: boolean;
}

function SensitiveFieldHelp({ fieldType }: SensitiveFieldHelpProps) {
  const [isHovered, setIsHovered] = useState(false);
  const explanation = SENSITIVE_FIELD_EXPLANATIONS[fieldType];

  return (
    <div className="relative ml-2 inline-block">
      <span
        className="cursor-help select-none text-xs text-gray-500 underline"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        Why does TACH need this?
      </span>

      {isHovered && (
        <div className="absolute bottom-full left-0 z-10 mb-2 w-64 rounded-md bg-gray-800 p-3 text-sm text-white shadow-lg">
          <div className="absolute bottom-[-4px] left-16 h-2 w-2 rotate-45 transform bg-gray-800"></div>
          {explanation}
        </div>
      )}
    </div>
  );
}

export default SensitiveFieldHelp;
